import * as React from "react";
import type { SVGProps } from "react";
const SvgTrain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#train_svg__a)">
      <path d="M13.51 18h-3.03C7.46 18 5 15.83 5 13.17v-6.4c0-1.36 1.02-3.24 2.64-3.92 2.72-1.11 6.01-1.1 8.71 0 1.63.69 2.64 2.57 2.65 3.92v6.41c0 2.67-2.46 4.84-5.49 4.84zM12 4c-1.24 0-2.48.24-3.6.69C7.59 5.03 7 6.17 7 6.76v6.4C7 14.73 8.56 16 10.49 16h3.03c1.92 0 3.49-1.27 3.49-2.84V6.77c0-.59-.6-1.73-1.42-2.07-1.1-.45-2.35-.69-3.58-.69z" />
      <path d="M12 12.06a18.7 18.7 0 0 1-4.17-.46C6.25 11.19 5.01 9.93 5 8.72V7.39c0-1.1 1.1-2.05 2.58-2.21 2.94-.23 5.89-.23 8.81 0 1.51.15 2.62 1.11 2.61 2.22v1.32c-.01 1.22-1.25 2.48-2.81 2.88h-.02c-1.34.31-2.75.47-4.17.47zM7 7.48v1.23c.03.17.52.74 1.3.94 2.37.54 5.01.55 7.4 0 .78-.2 1.26-.77 1.29-.96v-1.2c-.09-.09-.37-.27-.79-.31-2.79-.21-5.64-.22-8.45 0-.4.04-.67.22-.76.31zM8 22c-.16 0-.32-.04-.47-.12a.996.996 0 0 1-.42-1.35l2-3.79c.26-.49.86-.67 1.35-.42.49.26.68.86.42 1.35l-2 3.79c-.18.34-.53.53-.89.53zM16 22c-.36 0-.71-.19-.89-.53l-2-3.79a.996.996 0 0 1 .42-1.35.996.996 0 0 1 1.35.42l2 3.79c.26.49.07 1.09-.42 1.35-.15.08-.31.12-.47.12z" />
      <path d="M15 21H9c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1M14 15c-.13 0-.26-.02-.38-.08q-.18-.075-.33-.21c-.18-.19-.29-.45-.29-.71 0-.13.03-.26.08-.38q.075-.18.21-.33.15-.135.33-.21c.36-.16.81-.07 1.09.21q.135.15.21.33c.06.12.08.25.08.38 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29M10 15c-.26 0-.52-.11-.71-.29-.18-.19-.29-.45-.29-.71s.11-.52.29-.71c.28-.28.72-.37 1.09-.21.13.05.23.12.33.21.19.19.29.45.29.71s-.1.52-.29.71c-.19.18-.45.29-.71.29M12 11.58c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1v4.58c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="train_svg__a">
        <path fill="#fff" d="M5 2.02h14V22H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTrain;
